import Modifier from 'ember-modifier';
import tippy from 'tippy.js';

export default class Tippy extends Modifier {
  modify(element, [content], namedArgs) {
    if (!this.element) {
      this.element = element;
    }

    let options = {
      showOnCreate: false,
      placement: 'bottom',
      interactive: true,
      // Tooltips are a hover/keyboard affordance. On touch, tippy treats a tap as
      // a hover and the tooltip sticks open behind the tapped control — so disable
      // it for touch entirely (a caller can override with touch=true).
      touch: false,
      // Programmatic focus — a modal handing focus back to its trigger — is not
      // a reason to show a tooltip. Only real hover or visible keyboard focus is.
      onShow(instance) {
        let reference = instance.reference;
        if (
          reference.matches(':hover') ||
          reference.matches(':focus-visible')
        ) {
          return;
        }
        return false;
      },
      ...namedArgs,
      content,
    };

    if (['div', 'span'].includes(this.element.tagName)) {
      this.element.setAttribute('tabindex', '0');
    }

    if (this.element._tippy) {
      this.element._tippy.destroy();
    }

    tippy(this.element, options);
  }
}
